import React, { useState } from "react";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import eyeImg from "../../../assets/icons/eye.svg";
import { InputContainer } from "./Input.style";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";

type InputType = {
  name: string;
  type: string;
  placeholder?: string;
  disabled?: boolean;
  err?: string | null;
  defaultValue?: string;
  value: string;
  onChange: (e: any) => void;
  width?: string;
  lable?: string;
  options?: { value: any; label: string }[];
  className?: string;
};

const 
Input = ({
  name,
  type,
  placeholder,
  disabled,
  onChange,
  err,
  defaultValue,
  value,
  width = "100",
  lable,
  options,
  className,
}: InputType) => {
  
  const [showPassword, setShowPassword] = useState(false);
  if (type === "date") {
    return (
      <InputContainer width={width} className={className}>
        <p className="lable">{lable}</p>
        <Calendar
          id={name}
          inputId={name}
          name={name}
          dateFormat="yy/mm/dd"
          className={` ${classNames({
            "p-invalid": err,
          })}`}
          value={value}
          placeholder="YYYY/MM/DD"
          onChange={(e) => onChange(e)}
          readOnlyInput={true}
        />
        {err && <p className="p-error text-danger small ">{err}</p>}
      </InputContainer>
    );
  }
  if (type === "textarea") {
    return (
      <InputContainer width={width} className={className}>
        <p className="lable">{lable}</p>
        <InputTextarea
          // autoResize
          id={name}
          name={name}
          defaultValue={defaultValue}
          value={value}
          rows={4}
          onChange={(e) => onChange(e)}
          className={`form-control form-control-lg  ${classNames({
            "p-invalid": err,
          })}`}
          disabled={disabled}
          placeholder={placeholder}
        />
        {err && <p className="p-error text-danger small ">{err}</p>}
      </InputContainer>
    );
  } else if (type === "select") {
    return (
      <InputContainer width={width}>
        <p className="lable">{lable}</p>
        <Dropdown
          id={name}
          name={name}
          defaultValue={defaultValue}
          value={value}
          onChange={(e) => onChange(e)}
          options={options}
          className={`${classNames({
            "p-invalid": err,
          })}`}
          disabled={disabled}
          placeholder={placeholder}
        />
        {err && <p className="p-error text-danger small ">{err}</p>}
      </InputContainer>
    );
  } else {
    return (
      <InputContainer width={width} className={className}>
        {type === "password" && (
          <button
            type="button"
            tabIndex={-1}
            onClick={() => setShowPassword(!showPassword)}
            className={classNames({
              hide: showPassword,
              eye: true,
            })}
          >
            <img src={eyeImg} alt="eye" />
          </button>
        )}
        <p className="lable">{lable}</p>
        <InputText
          id={name}
          type={showPassword ? "text" : type}
          name={name}
          defaultValue={defaultValue}
          value={value}
          onChange={(e) => onChange(e)}
          className={`form-control form-control-lg  ${classNames({
            "p-invalid": err,
          })}`}
          disabled={disabled}
          placeholder={placeholder}
        />
        {err && <p className="p-error text-danger small ">{err}</p>}
      </InputContainer>
    );
  }
};

export default Input;
